import { GameMode } from "../proto/gunrun/v1/common_pb";

/** The playable modes in display order (GameMode.UNSPECIFIED is a wire default, never a choice). */
export const GAME_MODES: readonly GameMode[] = [GameMode.FFA, GameMode.TDM, GameMode.KOTH, GameMode.DEFUSAL];

const MODE_SLUGS: Readonly<Record<GameMode, string>> = {
  [GameMode.UNSPECIFIED]: "unspecified",
  [GameMode.FFA]: "ffa",
  [GameMode.TDM]: "tdm",
  [GameMode.KOTH]: "koth",
  [GameMode.DEFUSAL]: "defusal",
};

/** Built-in names, used until (or instead of) the catalog's `ModeInfo.name`. Same as gr_core `display_name`. */
const MODE_NAMES: Readonly<Record<GameMode, string>> = {
  [GameMode.UNSPECIFIED]: "Unknown mode",
  [GameMode.FFA]: "Free For All",
  [GameMode.TDM]: "Team Deathmatch",
  [GameMode.KOTH]: "King of the Hill",
  [GameMode.DEFUSAL]: "Defusal",
};

/** Stable lowercase slug ("ffa", "tdm", "koth", "defusal"): storage keys, map ids in URLs, class names. */
export function modeSlug(mode: GameMode): string {
  return MODE_SLUGS[mode] ?? MODE_SLUGS[GameMode.UNSPECIFIED];
}

/** Inverse of `modeSlug`; undefined for anything that is not a playable mode. */
export function modeFromSlug(slug: string): GameMode | undefined {
  return GAME_MODES.find((m) => MODE_SLUGS[m] === slug);
}

/** Default display name of a mode. Prefer `modeName` from state/meta once the catalog is loaded. */
export function defaultModeName(mode: GameMode): string {
  return MODE_NAMES[mode] ?? MODE_NAMES[GameMode.UNSPECIFIED];
}

/** True for every mode that has teams (everything except free for all). */
export function isTeamMode(mode: GameMode): boolean {
  return mode !== GameMode.FFA && mode !== GameMode.UNSPECIFIED;
}
